import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { debug } from 'console';
import { MenuItemModel } from 'src/app/core/models/analytics/menu-item-model';
import { ItemIdModel } from 'src/app/core/models/filter-model/item-id-model';
import { ImpactAssessmentDetailsT6DD } from 'src/app/core/models/impact-assessment/impact-assessment-detailsT6-dd';
import { ImpactAssessmentT6ListDto } from 'src/app/core/models/impact-assessment/impact-assessmentT6-list';
import { JurisdictionsList } from 'src/app/core/models/impact-assessment/jurisdictions-list-model';
import { FilterViewModel } from 'src/app/core/models/regulation';
import { UserProfile } from 'src/app/core/models/user';
import { UserDetailModel } from 'src/app/core/models/user-management/user-filter-model';
import { AlertDialogModel, ToastViewModel } from 'src/app/core/models/view-model';
import { SessionService } from 'src/app/core/services/auth/session.service';
import { ImpactService } from 'src/app/core/services/impact/impact.service';
import { UserManagementService } from 'src/app/core/services/user-management/user-management.service';
import { MasterHelper } from 'src/app/core/utilities';
import { DeleteDialogComponent } from '../../distributed-ui-components';
import { ImpactAssessmentDropDownList } from 'src/app/core/models/impact-assessment/impact-assessment-dropdown-list-model';
import { SelfAssessmentDocumentModel } from 'src/app/core/models/self-assessment/self-assessment-document-model';
import { LinkedIdModel } from 'src/app/core/models/impact-assessment/linked-id-model';
import { TimePickerComponent } from '../time-picker/time-picker.component';
import { UpdateImpactAssessmentT6Model } from 'src/app/core/models/impact-assessment/UpdateImpactAssessmentT6Modael';
import { VersionHistoryFilterModel } from 'src/app/core/models/view-model/version-history-filter-model';
import { ImpactAssessmentDialogComponent } from '../../impact-assessment/impact-assessment-dialog/impact-assessment-dialog.component';
import { FileType } from 'src/app/core/enums/user/file-type';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { LinkedAssessmentModel } from 'src/app/core/models/impact-assessment/linked-assessment-model';
import { LinkedAssessmentComponent } from '../../impact-assessment/linked-assessment/linked-assessment.component';
import { ImpactAssessmentDetailT6ListModel } from 'src/app/core/models/impact-assessment/impact-assessment-detailsT6-list-model';
import { HttpErrorResponse } from '@angular/common/http';
import { ModalDialogComponent } from '../../distributed-ui-components/modal-dialog/modal-dialog.component';
import { debugPort } from 'process';
import { ImpactRatingModelT6 } from 'src/app/core/models/impact-assessment/impact-outcome';
import { ImpactRatingDialogComponent } from '../../impact-assessment/impact-rating-dialog/impact-rating-dialog.component';
import { CommonService } from 'src/app/core/services/common/common.service';
import { RegulationDetail, RegulationDetailDto } from 'src/app/core/models/regulation/regulation-detail';
import { ChangeViewerDialogComponent } from '../../distributed-ui-components/change-viewer-dialog/change-viewer-dialog.component';
import { BulkCloseModel } from 'src/app/core/models/regulation/bulk-close-model';
import { RegulationService } from 'src/app/core/services/regulation';
import { NavigationExtras, Router } from '@angular/router';
import { DownloadReportModel } from 'src/app/core/models/view-model/download-report-model';
import { BulkInsertModel } from 'src/app/core/models/impact-assessment/bulk-insert-model';
import { GDPRService } from 'src/app/core/services/rulebook';

@Component({
  selector: 'app-impact-assessment-template6',
  templateUrl: './impact-assessment-template6.component.html',
  styleUrls: ['./impact-assessment-template6.component.scss']
})

export class ImpactAssessmentTemplate6Component {
  @Input()
  impactAssessmentId!: number;
  isToastShow = false;
  userAccessToken: UserProfile;
  allSearchedTopic: FilterViewModel[] = [];
  isLoading = false;
  ruleType: Array<string> = [];
  currentAssessmentStatus: Array<string> = [];
  assessmentActionStatus: Array<string> = [];
  reviewStatus: Array<string> = [];
  implementationType: Array<string> = [];
  implementationStatus: Array<string> = [];
  lineOfBusiness: Array<string> = [];

  allLineOfBusiness: Array<string> = [];
  isLoadingDD = false;
  addOnBlur = true;
  regulationInfo: RegulationDetail;
  searchedAssessor: FilterViewModel[] = [];
  searchedActionOwner: FilterViewModel[] = [];
  ckDetail: ImpactAssessmentDetailT6ListModel;
  searchedReviewer: FilterViewModel[] = [];
  searchedReviewerDel: FilterViewModel[] = [];
  separatorKeysCodes: number[] = [ENTER, COMMA];
  searchedImptOwner: FilterViewModel[] = [];
  searchedOwnerDel: FilterViewModel[] = [];
  isReviewLastEdited = false;
  searchedTopics: FilterViewModel[] = [];
  searchedJurisdiction!: any[];
  toastModel: ToastViewModel;
  isReviewRequired: boolean = false
  isImplementationLastEdited = false;
  updateIADetails: UpdateImpactAssessmentT6Model;
  isAssessmentLastEdited = false;
  searchAssessorCntrl: FormControl = new FormControl();
  searchActionOwnerCntrl: FormControl = new FormControl();
  searchAssessorDelCntrl: FormControl = new FormControl();
  searchReviewerCntrl: FormControl = new FormControl();
  searchReviewerDelCntrl: FormControl = new FormControl();
  searchImptOwnerCntrl: FormControl = new FormControl();
  searchOwnerDelCntrl: FormControl = new FormControl();
  searchTopicCntrl: FormControl = new FormControl();
  searchLegalEntityCntrl: FormControl = new FormControl();
  searchLineOfBusinessCntrl: FormControl = new FormControl();
  isSaved = false;
  searchedJuris: ItemIdModel[] = [];
  linkedAssessment: LinkedAssessmentModel;
  currentinfoId: number = 0;
  selectedJuris: ItemIdModel[] = [];
  lineOfBusinessDD: string[] = [];
  actionOwnerDD: string[] = [];
  allSearchedAssessor: FilterViewModel[] = [];
  bulkCloseData: BulkCloseModel;
  @ViewChild('assessorInput')
  assessorInput!: ElementRef<HTMLInputElement>;
  allSearchedActionOwner: FilterViewModel[] = [];
  allSearchedAssessorDel: FilterViewModel[] = [];
  allSearchedReviewer: FilterViewModel[] = [];
  allSearchedReviewerDel: FilterViewModel[] = [];
  allSearchedImptOwner: FilterViewModel[] = [];
  allSearchedOwnerDel: FilterViewModel[] = [];
  isRequiredFieldFilled!: boolean;
  isRDetails = false;
  isIDetails = false;
  summary = false
  intialImpactAssessment = false;
  reviewDetails = false;
  stakeholderImpactAssessment = false;
  implementationDetails = false;
  impactAssessment: ImpactAssessmentT6ListDto;
  userJurisdiction: Array<FilterViewModel>;
  isSavedPermission = false;
  isAuthorised = true;
  isADetailPermission = true;
  impactAssessmentDocument: Array<SelfAssessmentDocumentModel>;
  isRDetailPermission = true;
  isIDetailPermission = true;
  summaryPermission = true;
  isRDPermission = false;
  prevImpactRating = '';
  isIDPermission = false;
  selectable = true;
  isAssessmentLoader = false;
  isReviewLoader = false;
  linkedAssessmentIds: Array<LinkedIdModel>;
  isImplementationLoader = false;
  removable = true;
  assessorDD: string[] = [];
  @ViewChild('assessorAutocomplete')
  assessorAutocomplete!: MatAutocomplete;
  currentUserRole = '';
  impactAssessmentDD: ImpactAssessmentDetailsT6DD;
  isImpactRating = false;
  searchStr = '';
  sAssessmentLastEdited = false;
  isDeleteAllTopic: boolean = false;
  reviewerDD: string[] = [];
  @ViewChild('topicInput')
  topicInput!: ElementRef<HTMLInputElement>;
  @ViewChild('topicAutoComplete')
  topicAutoComplete!: MatAutocomplete;
  alertDialogModel: AlertDialogModel;
  @Input()
  filterType!: string;
  isAssessmentClose = false;
  @ViewChild('myFileInputT6') myFileInputT6: any;
  @ViewChild('reviewerInput')
  reviewerInput!: ElementRef<HTMLInputElement>;
  @ViewChild('reviewerAutocomplete')
  reviewerAutocomplete!: MatAutocomplete;
  @ViewChild('myFileInput2') myFileInput2: any;
  @ViewChild('myFileInput3') myFileInput3: any;
  jurisdictions!: JurisdictionsList;
  myTopicDD!: string[];
  downloadReportModel: DownloadReportModel;
  filterScreenType = '';
  libraryMenu: Array<MenuItemModel>;
  isAssessmentAccessable: boolean = false;
  isReviewAccessable: boolean = false;
  isImplementaionAccessable = false;
  isParentIdEdit = false;
  parentId = 0;
  @Input()
  idList: number[]=[];

  constructor(
    private sessionService: SessionService,
    private impactService: ImpactService,
    public dialog: MatDialog,
    private regulationService: RegulationService,
    public router: Router,
    private userService: UserManagementService,
    public commonService: CommonService,
    private gdprService: GDPRService
  ) {

    this.userAccessToken = new UserProfile();
    this.toastModel = new ToastViewModel();
    this.userJurisdiction = [];
    this.downloadReportModel = new DownloadReportModel();
    this.regulationInfo = new RegulationDetail();
    this.ckDetail = new ImpactAssessmentDetailT6ListModel();
    this.updateIADetails = new UpdateImpactAssessmentT6Model();
    this.alertDialogModel = new AlertDialogModel();
    this.libraryMenu = [];
    this.linkedAssessment = new LinkedAssessmentModel();
    this.linkedAssessmentIds = [];
    this.bulkCloseData = new BulkCloseModel();
    this.impactAssessmentDocument = [];
    this.impactAssessmentDD = new ImpactAssessmentDetailsT6DD();
    this.impactAssessment = new ImpactAssessmentT6ListDto();
  }
  ngOnInit(): void {
    this.filterScreenType = this.filterType;

    this.getUserProfile();
  }
  openDialog(): void {

    const filterDataModel = new VersionHistoryFilterModel();
    filterDataModel.id = this.impactAssessment.id;
    filterDataModel.versionId = this.impactAssessmentId;
    filterDataModel.filterType = this.filterScreenType;
    filterDataModel.templateNo = this.impactAssessment.templateNo;
    const dialogRef = this.dialog.open(ImpactAssessmentDialogComponent, {
      width: '750px',
      data: filterDataModel
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (this.filterScreenType === 'PopupWindow' && result) {
        this.filterType = 'version';
        this.impactAssessmentId = +result;
        this.fetchImpactAssessmentDetails();
        this.fetchJurisdiction();
        this.fetchImpactAssessmentDD();
      }
    });
  }
  getUserProfile(): void {
    this.sessionService.getLoginUserInfo().subscribe((result: UserProfile) => {
      this.userAccessToken = result;
      this.checkUserIAAuthentication();
      if (this.userAccessToken) {
        this.fetchUserDetails();
      }
    });
  }
  uploadEvidenceAssessment(): void {
    const fileInput = document.getElementById('uploadAssessmentT6') as HTMLElement;
    fileInput.click();
  }
  uploadEvidenceReview(): void {
    const fileInput = document.getElementById('uploadReviewT6') as HTMLElement;
    fileInput.click();
  }
  uploadEvidenceImplementation(): void {
    const fileInput = document.getElementById('uploadImplementationT6') as HTMLElement;
    fileInput.click();
  }
  downloadDocument(id: number, fileName: string, extension: string, fileType: string): void {
    let template = 6;
    if (fileType === 'AssessmentT6') {
      this.isAssessmentLoader = true;
    } else if (fileType === 'ReviewT6') {
      this.isReviewLoader = true;
    } else if (fileType === 'ImplementationT6') {
      this.isImplementationLoader = true;
    }
    this.impactService.downloadEvidenceT6(id, template)
      .subscribe((data: any) => {
        if (fileType === 'AssessmentT6') {
          this.isAssessmentLoader = false;
        } else if (fileType === 'ReviewT6') {
          this.isReviewLoader = false;
        } else if (fileType === 'ImplementationT6') {
          this.isImplementationLoader = false;
        }
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `${fileName}${extension}`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }

  handleFileInput(files: FileList): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.AssessmentT6);
    }
    this.myFileInputT6.nativeElement.value = '';
  }
  handleReviewInput(files: FileList): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.ReviewT6);
    }
    this.myFileInput2.nativeElement.value = '';
  }
  handleImplementationInput(files: FileList): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      this.uploadFileToActivity(files[i], FileType.ImplementationT6);
    }
    this.myFileInput3.nativeElement.value = '';
  }
  uploadFileToActivity(fileToUpload: any, fileType: FileType): void {

    let template = 6;
    if (fileType === FileType.AssessmentT6) {
      this.isAssessmentLoader = true;
    } else if (fileType === FileType.ReviewT6) {
      this.isReviewLoader = true;
    } else if (fileType === FileType.ImplementationT6) {
      this.isImplementationLoader = true;
    }
    this.impactService.uploadEvidenceT6(fileToUpload, fileType, this.impactAssessmentId, template).subscribe((data: any) => {
      this.fetchImpactAssessmentDocuments(fileType);
      if (fileType === FileType.AssessmentT6) {
        this.isAssessmentLoader = false;
        this.updateSectionLastEdited('Assessment');
      } else if (fileType === FileType.ReviewT6) {
        this.isReviewLoader = false;
        this.updateSectionLastEdited('Review');
      } else {
        this.isImplementationLoader = false;
        this.updateSectionLastEdited('Implementation');
      }
    }, (err: HttpErrorResponse) => {
      this.isAssessmentLoader = false;
      this.isReviewLoader = false;
      this.isImplementationLoader = false;
      this.alertMessage('warning', 'File not uploaded, please check your file');
      setTimeout(() => {
      }, 1000);
    });
  }
  openRegulationDialog(): void {
    this.regulationInfo.regulationId = this.impactAssessment.updatedDB_Id;
    this.regulationInfo.title = this.impactAssessment.title;
    this.regulationInfo.type = this.impactAssessment.pubType;
    this.regulationInfo.filterType = 'Linked Updates';
    this.regulationInfo.TabType = this.filterScreenType;
    const dialogRef = this.dialog.open(ChangeViewerDialogComponent, {
      width: '1000px',
      data: this.regulationInfo
    });
    dialogRef.afterClosed().subscribe(async (result: any) => {
      if (result) {
        this.isAssessmentClose = true;
        if (result.selectedLinkedIds && result.selectedLinkedIds.length > 0) {
          result.selectedLinkedIds.push(this.impactAssessment.updatedDB_Id);
          this.bulkCloseRegulations(result, 'Close');
        } else {
          this.updateRegulationDetail(result, this.impactAssessment.updatedDB_Id);
        }
      } else {
        this.regulationInfo = new RegulationDetail();
      }
    });
  }
  updateRegulationDetail(regulation: RegulationDetail, id: number): void {
    regulation.regulationId = id;
    regulation.userId = this.userAccessToken.externalUserId;
    regulation.isRead = true;
    regulation.status = +regulation.status;
    const regDto = new RegulationDetailDto();
    regDto.regulationDetails = regulation;
    regDto.screenName = 'Impact Assessment Details';
    this.regulationService.moveToRegulationDetail(regDto).subscribe(() => {
      this.alertMessage('success', 'Successfully updated');
      if (this.isAssessmentClose) {
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
        this.isAssessmentClose = false;
      }
    });
    //}
  }
  warningAlert(msg: string): void {
    this.toastModel.Title = 'Warning';
    this.toastModel.Type = 'warning';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
  successAlert(msg: string): void {
    this.toastModel.Title = 'Success';
    this.toastModel.Type = 'success';
    this.toastModel.Message = msg;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 5000);
  }
  bulkCloseRegulations(regDetails: RegulationDetail, filter: string): void {
    this.bulkCloseData.itemIds = regDetails.selectedLinkedIds;
    regDetails.userId = this.userAccessToken.externalUserId;
    regDetails.isRead = true;
    this.bulkCloseData.regulationDetail = regDetails;
    if (this.bulkCloseData.itemIds && this.bulkCloseData.itemIds.length > 50) {
      this.warningAlert('This operation may take a while to complete. The page will refresh upon completion. Please wait...');
    }
    this.bulkCloseData.regulationDetail.title = '';
    this.regulationService.regulationBulkClose(this.bulkCloseData).subscribe((result: any) => {
      this.alertMessage('success', 'Successfully updated');
      if (this.isAssessmentClose) {
        if (this.router.url.indexOf('/impact-assessment/details/') >= 0) {
          this.router.navigate([
            "/impact-assessment/summary/"
          ]);
        }
        else if (this.router.url.includes('/change-viewer')) {
          this.dialog.closeAll();
        }
        this.isAssessmentClose = false;
      }
    });
  }
  openDeleteModel(id: number, fileType: string): void {
    const dialogRef = this.dialog.open(ModalDialogComponent, {
      data: {
        message: 'Are you sure want to delete?',
        title: 'Delete Document',
        btnText: 'Delete',
      }
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (data) {
        this.removeImpactAssessmentDocuments(id, fileType);
      }
    });
  }
  removeImpactAssessmentDocuments(id: number, fileType: string): void {
    if (fileType === 'AssessmentT6') {
      this.isAssessmentLoader = true;
    } else if (fileType === 'ReviewT6') {
      this.isReviewLoader = true;
    } else if (fileType === 'ImplementationT6') {
      this.isImplementationLoader = true;
    }
    this.impactService.deleteImpactAssessmentDocumentT6(id).subscribe((data: any) => {
      if (fileType === 'AssessmentT6') {
        this.isAssessmentLoader = false;
        this.fetchImpactAssessmentDocuments(FileType.AssessmentT6);
      } else if (fileType === 'ReviewT6') {
        this.isReviewLoader = false;
        this.fetchImpactAssessmentDocuments(FileType.ReviewT6);
      } else if (fileType === 'ImplementationT6') {
        this.isImplementationLoader = false;
        this.fetchImpactAssessmentDocuments(FileType.ImplementationT6);
      }
      if (data.result) {
        this.alertMessage('success', data.result);
      }
    });
  }
  addAssessor(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.assessorAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.assessorDD.filter(
          obj => obj === value);

        if (sameValueRow.length == 0) {
          (this.assessorDD as string[]).push(value);
          this.filterReviewerListBasedOnAssessor()
        }
      }
      event.chipInput!.clear();
      this.searchAssessorCntrl.setValue(null);
      this.updateSectionLastEdited('Assessor');
    }
  }
  getImpactAssesmentDropdownList(jurisdiction: string): void {

    this.impactService.getImpactAssesmentDropDownList(jurisdiction).subscribe((result: ImpactAssessmentDropDownList) => {

      result.assessmentActionStatus.forEach(element => {
        this.assessmentActionStatus.push(element.title)
      });
      result.currentStatus.forEach(element => {
        this.currentAssessmentStatus.push(element.title)
      });
      result.reviewStatus.forEach(element => {
        this.reviewStatus.push(element.title)
      });
      result.implementationType.forEach(element => {
        this.implementationType.push(element.title)
      });
      result.ruleType.forEach(element => {
        this.ruleType.push(element.title)
      });
      result.implementationStatus.forEach(element => {
        this.implementationStatus.push(element.title)
      });
      result.lineOfBusiness.forEach(element => {
        this.lineOfBusiness.push(element.title)
        this.allLineOfBusiness = this.lineOfBusiness;
      });


    });
  }
  openLinkedAssessment(id: number): void {
    if (this.filterType === 'PopupWindow') {
      this.impactAssessmentId = id;
      this.fetchImpactAssessmentDetails();
      this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    } else {
      window.location.href = '/impact-assessment/details/impact/' + id;
    }
  }
  fetchUserDetails(): void {
    this.userService.getUserDetails().subscribe((result: UserDetailModel) => {
      this.userJurisdiction = result.userJurisdiction;
      this.libraryMenu = result.libraryMenu;
      this.currentUserRole = result && result.role.title ? result.role.title : '';
      this.fetchImpactAssessmentDetails();
      this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    });
  }
  removeAssessor(status: string): void {
    let assessors = [];
    assessors = this.impactAssessment.assessor ? this.impactAssessment.assessor.split(',') : this.assessorDD;
    if (status === this.userAccessToken.fullName && assessors.includes(status)) {
      this.alertDialogModel.HeadingText = 'Assessment Assessor';
      this.alertDialogModel.BodyText = 'Are you sure you want to remove yourself as an assessor? If you do this, you will no longer be able to edit this assessment. The change will not be submitted until the assessment is saved.';
      this.alertDialogModel.ActionButtonText = 'Yes';
      this.alertDialogModel.cancelButtonText = "No";
      this.alertDialogModel.IsAction = true;

      const dialogRef = this.dialog.open(DeleteDialogComponent, {
        width: '450px',
        data: this.alertDialogModel
      });
      dialogRef.afterClosed().subscribe((result: any) => {
        if (result == "Assessment Assessor") {
          const index = (this.assessorDD as string[]).indexOf(status);

          if (index >= 0) {
            (this.assessorDD as string[]).splice(index, 1);
            this.addReviewerAfterAssessorRemove(status);
            this.updateSectionLastEdited('Assessor');
          }
        }
      });
    }
    else {
      const index = (this.assessorDD as string[]).indexOf(status);

      if (index >= 0) {
        (this.assessorDD as string[]).splice(index, 1);
        this.addReviewerAfterAssessorRemove(status);
        this.updateSectionLastEdited('Assessor');
      }
    }
  }
  checkUserIAAuthentication(): void {
    this.impactService.getIAUsers(this.impactAssessmentId).subscribe((result: string[]) => {
      this.isSavedPermission = result.indexOf(this.userAccessToken.fullName) >= 0 ? true : false;
    });
  }

  getFilteredData(filter: string, event: any): void {

    this.searchStr += event.key;
    switch (filter) {
      case 'Assessor':
        const searchedA = Array<FilterViewModel>();
        if (this.searchedAssessor.length > 0) {
          this.searchedAssessor.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedA.push(element);
            }
          });
          this.searchedAssessor = searchedA;
        } else {
          this.searchedAssessor = this.allSearchedAssessor;
        }
        break;
      case 'Reviewer':
        const searchedR = Array<FilterViewModel>();
        if (this.searchedReviewer.length > 0) {
          this.searchedReviewer.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedR.push(element);
            }
          });
          this.searchedReviewer = searchedR;
        } else {
          this.searchedReviewer = this.allSearchedReviewer;
        }
        break;
      case 'Topic':
        const searchedT = Array<FilterViewModel>();
        if (this.searchedTopics.length > 0) {
          this.searchedTopics.forEach(element => {
            if (element.value.toLowerCase().includes(this.searchStr.toLowerCase())) {
              searchedT.push(element);
            }
          });
          this.searchedTopics = searchedT;
        } else {
          this.searchedTopics = this.allSearchedTopic;
        }
        break;
    }
    this.searchStr = '';
  }

  fetchImpactAssessmentDD(): void {
    this.isLoadingDD = true;
    this.impactService.getImpactAssessmentT6DD().subscribe((result: ImpactAssessmentDetailsT6DD) => {
      this.isImpactRating = true;
      this.isLoadingDD = false;
      this.impactAssessmentDD = result;
      this.ddListData();
      this.selectedDDvalue();
    });
  }
  deleteAllTopic() {
    this.openDeleteDialog()
  }
  openDeleteDialog(): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Delete Item') {
        this.myTopicDD = [];
        this.impactAssessment.ruleTopic = '';
        this.isDeleteAllTopic = false;
      }
      else {
        this.isDeleteAllTopic = false;
      }
    });
  }
  selectedTopicEvent(event: MatAutocompleteSelectedEvent): void {
    var newValue = event.option.viewValue.trim().toLowerCase();
    if (this.myTopicDD != null) {
      let filteredTopic = this.myTopicDD.filter(s => s.toLowerCase() == newValue);
      if (filteredTopic.length == 0) {
        if (this.myTopicDD) {
          this.myTopicDD.push(event.option.viewValue);
        }
        else {
          this.myTopicDD = [];
          this.myTopicDD.push(event.option.viewValue);
        }
      }
    }
    else {
      this.myTopicDD = [];
      this.myTopicDD.push(event.option.viewValue);
    }
    this.impactAssessment.ruleTopic = this.myTopicDD.join(',');
    this.topicInput.nativeElement.value = '';
    this.searchTopicCntrl.setValue(null);
    this.searchTopicCntrl.disable();
    this.searchTopicCntrl.enable();
  }
  filterTopic(search: string): any {
    return this.searchedTopics.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  sortArray(itemArray: string[]): string[] {
    return MasterHelper.sortArray(itemArray, 'asc');
  }
  fetchFromBrowser(key: string): any {
    return localStorage.getItem(key);
  }
  openImpactRating(): void {
    const ratingInfo = new ImpactRatingModelT6();
    ratingInfo.impactAssessment = this.impactAssessment;
    ratingInfo.jurisdictionList = this.impactAssessmentDD.jurisdiction;
    ratingInfo.userAccessToken = this.userAccessToken;
    const dialogRef = this.dialog.open(ImpactRatingDialogComponent, {
      width: '1800px',
      height: '850px',
      data: ratingInfo
    });
    dialogRef.afterClosed().subscribe((result: any) => {

      const savedDetails = JSON.parse(this.fetchFromBrowser('_imasd') as string) as ImpactAssessmentT6ListDto;
      if (savedDetails) {
        this.impactAssessment.impactRating = savedDetails.impactRating;
      }
      MasterHelper.removeFromBrowser('_imasd');
    });
  }
  ddListData(): void {
    this.searchedAssessor = this.impactAssessmentDD.assessor;
    this.searchedReviewer = this.impactAssessmentDD.reviewer;

    this.searchedJuris = this.impactAssessmentDD.jurisdiction;
    this.searchedTopics = this.impactAssessmentDD.ruleTopics;

    this.allSearchedAssessor = this.impactAssessmentDD.assessor;
    this.allSearchedReviewer = this.impactAssessmentDD.reviewer;
    this.allSearchedTopic = this.impactAssessmentDD.ruleTopics;

    this.searchTopicCntrl.valueChanges.subscribe((term: any) => {
      this.searchedTopics = term ? this.filterTopic(term) : this.impactAssessmentDD.ruleTopics;
    });
    this.searchAssessorCntrl.valueChanges.subscribe((term: any) => {
      this.searchedAssessor = term ? this.filterAssessor(term) : this.impactAssessmentDD.assessor;
      this.searchedJurisdiction = term ? this.filterJurisdiction(term) : this.jurisdictions.jurisdictions;
    });
    this.searchReviewerCntrl.valueChanges.subscribe((term: any) => {
      this.searchedReviewer = term ? this.filterReviewer(term) : this.impactAssessmentDD.reviewer;
    });
    
  }
  
  filterReviewer(search: string): any {
    return this.searchedReviewer.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterAssessor(search: string): any {
    return this.searchedAssessor.filter(option =>
      option.name.toLowerCase().includes(search.toLowerCase())
    );
  }
  filterJurisdiction(search: string): any {
    return this.searchedJurisdiction.filter(option =>
      option.title.toLowerCase().includes(search.toLowerCase())
    );
  }
  removeTopic(status: string): void {
    var newStatus = status.trim();
    for (let i = 0; i < this.myTopicDD.length; i++) {
      if (this.myTopicDD[i].trim() == newStatus) {
        (this.myTopicDD).splice(i, 1);
      }
    }
    this.impactAssessment.ruleTopic = this.myTopicDD.join(',');
  }
  selectedDDvalue(): void {
    this.reviewerDD = this.impactAssessment.stakeholder ? this.impactAssessment.stakeholder.split(',') : this.reviewerDD;
    this.lineOfBusinessDD = this.impactAssessment.assessor ? this.impactAssessment.assessor.split(',') : this.assessorDD;
    this.assessorDD = this.impactAssessment.assessor ? this.impactAssessment.assessor.split(',') : this.assessorDD;
    if (this.impactAssessment.ruleTopic != null && this.impactAssessment.ruleTopic != "") {
      this.myTopicDD =  this.impactAssessment.ruleTopic?this.impactAssessment.ruleTopic.split(','):[];
    }
    if (this.impactAssessment.jurisdiction) {
      this.impactAssessment.jurisdiction.split(',').forEach(juris => {
        this.selectedJuris.push({ id: 0, name: juris });
      });
    }
  }

  downloadReport(): void {
    this.isLoading = true;
    this.downloadReportModel.id = this.impactAssessmentId;
    const parsedUrl = new URL(window.location.href);
    this.downloadReportModel.currentUrl = parsedUrl.origin;
    this.impactService.downloadIAReport(this.downloadReportModel)
      .subscribe((data: any) => {
        this.isLoading = false;
        // tslint:disable-next-line:one-variable-per-declaration
        const a = document.createElement('a'),
          fileURL = URL.createObjectURL(data);
        a.href = fileURL;
        a.download = `ImpactAssessmentReport.csv`;
        window.document.body.appendChild(a);
        a.click();
        window.document.body.removeChild(a);
      }, (err: HttpErrorResponse) => {
        this.isLoading = false;
        console.error(JSON.stringify(err.message));
      });
  }
  updateImpactAssessment(): void {

    if (this.selectedJuris.length === 0) {
      this.alertMessage('warning', 'Please select jurisdiction');
    } else {
      if (this.impactAssessment.isRecordTime) {
        const dialogRef = this.dialog.open(TimePickerComponent, {
          width: '330px',
          panelClass: 'custom-time-modal'
        });

        dialogRef.afterClosed().subscribe((result: any) => {
          if (result) {
            this.impactAssessment.timeSpent = this.impactAssessment.timeSpent + result;
            this.updateImpactAssessmentDetails();
          }
        });
      }
      else {
        this.updateImpactAssessmentDetails();
      }

    }
  }
  onReviewRequiredChange(value: string): void {
    this.impactAssessment.isReviewRequired = (value === 'true'); // Convert string to boolean
  }
  onImplimentationRequiredChange(value: string): void {
    this.impactAssessment.isImplementationRequired = (value === 'true'); // Convert string to boolean
  }
  addReviewer(event: MatChipInputEvent): void {
    const value = event.value;
    if (!this.reviewerAutocomplete.isOpen) {
      if ((value || '').trim()) {
        let sameValueRow = this.reviewerDD.filter(
          obj => obj === value);
        if (sameValueRow.length == 0) {
          (this.reviewerDD as string[]).push(value);
          this.filterAssessorListBasedOnReviewer();
        }
      }
      event.chipInput!.clear();
      this.searchReviewerCntrl.setValue(null);
      this.updateSectionLastEdited('Reviewer');
    }
  }
  selectedReviewerEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.reviewerDD) {
      let sameValueRow = this.reviewerDD.filter(obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.reviewerDD.push(event.option.viewValue);
        this.filterAssessorListBasedOnReviewer();
      }

    } else {
      this.reviewerDD = [];
      this.reviewerDD.push(event.option.viewValue);
      this.filterAssessorListBasedOnReviewer();
    }
    if (this.reviewerInput) {
      this.reviewerInput.nativeElement.value = '';
    }
    this.searchReviewerCntrl.setValue(null);
    this.searchReviewerCntrl.disable();
    this.searchReviewerCntrl.enable();
    this.updateSectionLastEdited('Reviewer');
  }
  removeReviewer(status: string): void {
    const index = (this.reviewerDD as string[]).indexOf(status);

    if (index >= 0) {
      (this.reviewerDD as string[]).splice(index, 1);
      this.addAssessorAfterReviewerRemove(status);
      this.updateSectionLastEdited('Reviewer');
    }
  }

  updateImpactAssessmentDetails(): void {
    this.isSaved = true;
    this.isLoading = true;
    this.isRequiredFieldFilled = true;

    if (this.isAssessmentLastEdited) {
      this.impactAssessment.assessmentLastEdited = MasterHelper.getDate(0);
    }
    if (this.isReviewLastEdited) {
      this.impactAssessment.reviewLastEdited = MasterHelper.getDate(0);
    }
    if (this.isImplementationLastEdited) {
      this.impactAssessment.implementationLastEdited = MasterHelper.getDate(0);
    }
    if (this.prevImpactRating !== this.impactAssessment.impactRating) {

      this.updateIADetails.isImpactRating = true;
    }
    this.impactAssessment.assessor = this.assessorDD.toString();
    //New code added for Template 2 Action taken
    //Start here

    this.impactAssessment.assessmentLastEdited = new Date();
    this.impactAssessment.jurisdiction =
      this.selectedJuris.length > 0 ? MasterHelper.getStringFromObjectArray(this.selectedJuris) : '';
    if (this.myTopicDD != null) {
      this.impactAssessment.ruleTopic = this.myTopicDD.join(',');
    }

    this.impactAssessment.stakeholder = this.reviewerDD.toString();
    this.impactAssessment.applicationDate = this.impactAssessment.applicationDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.applicationDate.toString()) : null;
    this.impactAssessment.assessmentLastEdited = this.impactAssessment.assessmentLastEdited ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.assessmentLastEdited.toString()) : null;
    this.impactAssessment.assessmentDueDate = this.impactAssessment.assessmentDueDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.assessmentDueDate.toString()) : null;
    this.impactAssessment.reviewLastEdited = this.impactAssessment.reviewLastEdited ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.reviewLastEdited.toString()) : null;
    this.impactAssessment.reviewDueDate = this.impactAssessment.reviewDueDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.reviewDueDate.toString()) : null;
    this.impactAssessment.implementationLastEdited = this.impactAssessment.implementationLastEdited ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.implementationLastEdited.toString()) : null;
    this.impactAssessment.implementationDueDate = this.impactAssessment.implementationDueDate ?
      MasterHelper.bsdatePickerToCorrectDate(this.impactAssessment.implementationDueDate.toString()) : null;
    this.impactAssessment.userId = this.userAccessToken.externalUserId;
    this.impactAssessment.userName = this.userAccessToken.fullName;
    const currentUrl = window.location.href;
    this.updateIADetails.impactAssessment = this.impactAssessment;
    this.impactService.updateImpactAssessmentT6(this.updateIADetails, currentUrl).subscribe((result: ImpactAssessmentT6ListDto) => {
      this.isLoading = false;
      this.impactAssessment = result;
      this.alertMessage('success', 'Successfully updated');
      this.isSaved = false;
      this.updateIADetails = new UpdateImpactAssessmentT6Model();
      if (result.previousImpactAsss_Id) {
        this.getLinkedIds();
      }
      this.isRDetails = false;
      this.isIDetails = false;
      this.summary = false;
      this.intialImpactAssessment = false;
      this.reviewDetails = false;
      this.stakeholderImpactAssessment = false;
      this.implementationDetails = false;
    });
  }

  backToCurrentVersion(): void {
    if (this.filterScreenType === 'PopupWindow') {
      this.filterType = this.filterScreenType;
      this.impactAssessmentId = this.impactAssessment.id;
      this.fetchImpactAssessmentDetails();
      this.fetchJurisdiction();
      this.fetchImpactAssessmentDD();
    } else {
      window.location.href = 'impact-assessment/details/impact/' + this.impactAssessment.templateNo + '/' + this.impactAssessment.id;
    }
  }
  dateFormat(effectiveDate: string): void {
    const eDate = effectiveDate ? effectiveDate.split('|')[0] : MasterHelper.getDateStr(0);
    return MasterHelper.formatDate(eDate, 'YYYY-MM-DD');
  }

  checkRoutePermission(currentUrl: string): boolean {
    return this.libraryMenu.find(a => a.screenName === currentUrl && a.parentId != null) ? true : false;
  }
  fetchImpactAssessmentDocuments(fileType: FileType): void {
    if (fileType === FileType.AssessmentT6) {
      this.isAssessmentLoader = true;
    } else if (fileType === FileType.ReviewT6) {
      this.isReviewLoader = true;
    } else {
      this.isImplementationLoader = true;
    }
    this.impactService.getImpactAssessmentDocumentsT6(this.impactAssessmentId).subscribe((result: SelfAssessmentDocumentModel[]) => {
      this.impactAssessmentDocument = result;
      if (fileType === FileType.AssessmentT6) {
        this.isAssessmentLoader = false;
      } else if (fileType === FileType.ReviewT6) {
        this.isReviewLoader = false;
      } else {
        this.isImplementationLoader = false;
      }
    });
  }
  alertMessage(type: string, message: string): void {
    if (type === 'success') {
      this.toastModel.Title = 'Success';
      this.toastModel.Type = 'success';
    } else {
      this.toastModel.Title = 'Warning';
      this.toastModel.Type = 'warning';
    }
    this.toastModel.Message = message;
    this.isToastShow = true;
    setTimeout(() => {
      this.isToastShow = false;
    }, 3000);
  }
  updateSectionLastEdited(filter: string): void {
    switch (filter) {
      case 'Assessment':
        this.isAssessmentLastEdited = true;
        break;
      case 'ActionOwner':
        this.isAssessmentLastEdited = true;
        break;
      case 'AssessmentTeam':
        this.isAssessmentLastEdited = true;
        this.updateIADetails.isAssessmentTeam = true;
        break;
      case 'Assessor':
        this.isAssessmentLastEdited = true;
        this.updateIADetails.isAssessor = true;
        break;
      case 'AssessorDelegate':
        this.isAssessmentLastEdited = true;
        this.updateIADetails.isAssessorDel = true;
        break;
      case 'currentAssessmentStatus':
        this.isAssessmentLastEdited = true;
        this.updateIADetails.isAssessmentStatus = true;
        break;
      case 'AssessmentActionStatus':
        this.isAssessmentLastEdited = true;
        this.updateIADetails.isAssessmentStatus = true;
        break;
      case 'ImplementationType':
        this.isImplementationLastEdited = true;
        this.updateIADetails.isImplementationType = true;
        break;
      case 'Review':
        this.isReviewLastEdited = true;
        break;
      case 'ReviewerTeam':
        this.isReviewLastEdited = true;
        this.updateIADetails.isReviewerTeam = true;
        break;
      case 'Reviewer':
        this.isReviewLastEdited = true;
        this.updateIADetails.isReviewer = true;
        break;
     
      case 'ReviewStatus':
        this.isReviewLastEdited = true;
        this.updateIADetails.isReviewStatus = true;
        break;
      case 'Implementation':
        this.isImplementationLastEdited = true;
        break;
      case 'ImplementationTeam':
        this.isImplementationLastEdited = true;
        this.updateIADetails.isImplementationTeam = true;
        break;
      case 'ImplementationOwner':
        this.isImplementationLastEdited = true;
        this.updateIADetails.isImplementationOwner = true;
        break;
      case 'OwnerDel':
        this.isImplementationLastEdited = true;
        this.updateIADetails.isOwnerDel = true;
        break;
      case 'ImplementationStatus':
        this.isImplementationLastEdited = true;
        this.updateIADetails.isImplementationStatus = true;
        break;

    }
  }
  selectedAssessorEvent(event: MatAutocompleteSelectedEvent): void {
    if (this.assessorDD) {
      let sameValueRow = this.assessorDD.filter(
        obj => obj === event.option.viewValue);
      if (sameValueRow.length == 0) {
        this.assessorDD.push(event.option.viewValue);
        this.filterReviewerListBasedOnAssessor();
      }
    } else {
      this.assessorDD = [];
      this.assessorDD.push(event.option.viewValue);
      this.filterReviewerListBasedOnAssessor();
    }
    if (this.assessorInput) {
      this.assessorInput.nativeElement.value = '';
    }
    this.searchAssessorCntrl.setValue(null);
    this.searchAssessorCntrl.disable();
    this.searchAssessorCntrl.enable();
    this.updateSectionLastEdited('Assessor');
  }
  addTopic(event: MatChipInputEvent, topicString: string): void {
    if (!this.topicAutoComplete.isOpen) {
      const input = event.chipInput ? event.chipInput.inputElement : null;
      const value = event.value;
      if ((value || '').trim()) {
        if (!this.myTopicDD) {
          this.myTopicDD = [];
        }
        (this.myTopicDD).push(value);
        this.impactAssessment.ruleTopic = this.myTopicDD.join(',');
      }

      if (input) {
        input.value = '';
      }
      this.searchTopicCntrl.setValue(null);
    }
  }
  fetchImpactAssessmentDetails(): void {
    this.isLoading = true
    this.impactService.getImpactAssessmentDetailsT6(this.impactAssessmentId, this.filterType).
      subscribe((result: any) => {
        this.impactAssessment = result;
        this.myTopicDD =this.impactAssessment.ruleTopic?this.impactAssessment.ruleTopic.split(','):[];
        let assessor: any[] = this.impactAssessment.assessor ? this.impactAssessment.assessor.split(',') : [];
        let stakeholder: string[] = this.impactAssessment.stakeholder ? this.impactAssessment.stakeholder.split(',') : [];

        if (this.currentUserRole == 'Compliance Enterprise' || assessor.includes(this.userAccessToken.fullName)) {
          this.isAssessmentAccessable = true;
          this.isReviewAccessable = true;
          this.isSavedPermission = true;
        }
        else if (stakeholder.includes(this.userAccessToken.fullName)) {
          this.isAssessmentAccessable = false;
          this.isReviewAccessable = true;
          this.isSavedPermission = true;
        }
        else {
          this.isAssessmentAccessable = false;
          this.isReviewAccessable = false;
          this.isSavedPermission = false;
        }

        this.getImpactAssesmentDropdownList(result.jurisdiction);
        this.prevImpactRating = this.impactAssessment.impactRating;
        this.impactAssessment.ruleType = this.impactAssessment.ruleType ? this.impactAssessment.ruleType : 'Draft Rule';
        this.isLoading = false;
        if (this.impactAssessment.previousImpactAsss_Id) {
          this.getLinkedIds();
        }
        this.checkUserPermission();
        this.getAssessmentDocuments();
        this.fetchPermissionByJurisdiction(this.userJurisdiction);
        this.currentinfoId = this.impactAssessment.updatedDB_Id;
      })
  }
  openLADialog(): void {
    this.linkedAssessment.impactAssessmentId = this.impactAssessmentId;
    if (this.impactAssessment.previousImpactAsss_Id) {
      const ids = this.impactAssessment.previousImpactAsss_Id.split(',');
      ids.forEach(element => {
        this.linkedAssessment.linkedAssessment.push(+element);
        this.linkedAssessment.templateNumber = this.impactAssessment.templateNo;
      });
    }
    this.linkedAssessment.templateNumber = this.impactAssessment.templateNo;
    const dialogRef = this.dialog.open(LinkedAssessmentComponent, {
      width: '1500px',
      data: this.linkedAssessment
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
        this.linkedAssessment = result;
        this.saveLinkedAssessment();
      }
    });
  }
  saveLinkedAssessment(): void {
    this.isLoading = true;
    this.impactService.saveLinkedAssessmentT6(this.linkedAssessment).subscribe((result: LinkedAssessmentModel) => {
      this.isLoading = false;
      this.linkedAssessment = new LinkedAssessmentModel();
      this.impactAssessment.previousImpactAsss_Id = result.linkedAssessment.toString();
      if (this.impactAssessment.previousImpactAsss_Id) {
        this.getLinkedIds();
      }
    });
  }
  fetchPermissionByJurisdiction(userJurisdiction: FilterViewModel[]): void {
    if (this.currentUserRole !== 'Compliance Enterprise') {
      if (this.impactAssessment.jurisdiction) {
        const jurisArr = this.impactAssessment.jurisdiction.split(',');
        jurisArr.forEach(element => {
          if (!userJurisdiction.some(a => a.value === element)) {
            this.isAuthorised = false;
          }
        });
      }
    } else {
      this.isAuthorised = true;
    }
  }
  checkUserPermission(): void {
    if (this.currentUserRole !== 'Compliance Enterprise' && this.currentUserRole !== 'Horizon Scanning SuperUser'
      && this.impactAssessment.userId !== this.userAccessToken.externalUserId) {
      // Assessment Details Permission
      this.isADetailPermission = this.impactAssessment.assessor &&
        (this.impactAssessment.assessor.split(',') as string[]).indexOf(this.userAccessToken.fullName) >= 0 ? true : false;

      // Review Details Permission


      this.isIDPermission = this.isIDetailPermission;
    } else {
      this.isRDPermission = true;
      this.isIDPermission = true;
    }
    const reviewState = this.impactAssessment.isReviewRequired ? 'Checked' : 'UnChecked';
    // this.checkReviewDetailRequired(reviewState);
    const idState = this.impactAssessment.isImplementationRequired ? 'Checked' : 'UnChecked';
    // this.checkImplementationDetailRequired(idState);
  }
  getUpdatedDbInfo(id: number) {
    if (this.currentinfoId != id) {
      this.isLoading = true;
      this.impactService.getImpactAssessmentRegulationDetails(id).subscribe((data: any) => {
        this.impactAssessment.title = data.title;
        this.impactAssessment.description = data.description;
        this.impactAssessment.pubType = data.pubType;
        this.impactAssessment.geography = data.geography;
        this.impactAssessment.regulator = data.regulator;
        this.impactAssessment.updatedDB_Date = data.updatedDB_Date;
        this.impactAssessment.country = data.country;
        this.currentinfoId = id;
        this.isLoading = false;
      });
    }

  }
  fetchJurisdiction(): void {
    this.impactService.GetJurisdictionsList().subscribe((result: JurisdictionsList) => {
      this.jurisdictions = result;

      this.searchedJurisdiction = this.jurisdictions.jurisdictions;
    })
  }

  getAssessmentDocuments(): void {

    this.isAssessmentLoader = true;
    this.isReviewLoader = true;
    this.impactService.getImpactAssessmentDocumentsT6(this.impactAssessmentId).subscribe((result: SelfAssessmentDocumentModel[]) => {
      this.impactAssessmentDocument = result;
      this.isAssessmentLoader = false;
      this.isReviewLoader = false;
    });
  }
  getLinkedIds(): void {
    this.impactService.getLinkedIdsT6(this.impactAssessment.previousImpactAsss_Id).subscribe((result: LinkedIdModel[]) => {
      this.linkedAssessmentIds = result;
    });
  }
  // scrollHandler(event: any) {
  //   if (this.topicAutoComplete?.isOpen) {
  //     this.trigautoTopic.closePanel();
  //     this.topicInput.nativeElement.blur();
  //   }

  //   if (this.assessorAutocomplete?.isOpen) {
  //     this.trigautoAssessor.closePanel();
  //     this.assessorInput.nativeElement.blur();
  //   }

  //   if (this.assessorDelAutocomplete?.isOpen) {
  //     this.trigautoAssessorDelegate.closePanel();
  //     this.assessorDelInput.nativeElement.blur();
  //   }

  //   if (this.reviewerAutocomplete?.isOpen) {
  //     this.trigautoReviewer.closePanel();
  //     this.reviewerInput.nativeElement.blur();
  //   }

  //   if (this.reviewerDelAutocomplete?.isOpen) {
  //     this.trigautoReviewerDelegate.closePanel();
  //     this.reviewerDelInput.nativeElement.blur();
  //   }

  //   if (this.imptOwnerAutocomplete?.isOpen) {
  //     this.trigautoImpOwner.closePanel();
  //     this.imptOwnerInput.nativeElement.blur();
  //   }

  //   if (this.ownerDelAutocomplete?.isOpen) {
  //     this.trigautoOwnerDelegate.closePanel();
  //     this.ownerDelInput.nativeElement.blur();
  //   }
  //   if (this.legalEntityAutocomplete?.isOpen) {
  //     this.trigautoLegalEntity.closePanel();
  //     this.LegalEntityInput.nativeElement.blur();
  //   }
  //   this.impactService.impactAssessmentTemplate3ScrollNotifyOther({ refresh: true });
  // }
  filterReviewerListBasedOnAssessor() {
    this.searchedReviewer = this.searchedReviewer.filter(reviewer => !this.assessorDD.includes(reviewer.value));
  }
  filterAssessorListBasedOnReviewer() {
    this.searchedAssessor = this.searchedAssessor.filter(assessor => !this.reviewerDD.includes(assessor.value));
  }
  addReviewerAfterAssessorRemove(status: string) {
    let reviewFilterRow = this.allSearchedReviewer.filter(ob => ob.name == status);
    let reviewSearchedFilterRow = this.searchedReviewer.filter(ob => ob.name == status);
    if (reviewFilterRow.length > 0 && reviewSearchedFilterRow.length == 0) {
      this.searchedReviewer.push(reviewFilterRow[0]);
      this.searchedReviewer = this.searchedReviewer.sort((a, b) => a.name.localeCompare(b.name));
    }
  }
  addAssessorAfterReviewerRemove(status: string) {
    let assessorFilterRow = this.allSearchedAssessor.filter(ob => ob.name == status);
    let assessorSearchedFilterRow = this.searchedAssessor.filter(ob => ob.name == status);
    if (assessorFilterRow.length > 0 && assessorSearchedFilterRow.length == 0) {
      this.searchedAssessor.push(assessorFilterRow[0]);
      this.searchedAssessor = this.searchedAssessor.sort((a, b) => a.name.localeCompare(b.name));
    }
  }

  updateOtherMergedId(item: any) {
    this.openDeleteDialogForLinkedId(item);
  }
  openDeleteDialogForLinkedId(item: any): void {
    this.alertDialogModel.HeadingText = 'Delete Item';
    this.alertDialogModel.BodyText = 'Are you sure you want to delete this Linked Id ' + item + ' ?';
    this.alertDialogModel.ActionButtonText = 'Delete';
    this.alertDialogModel.IsAction = true;

    const dialogRef = this.dialog.open(DeleteDialogComponent, {
      width: '450px',
      data: this.alertDialogModel
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if (result === 'Delete Item') {
        item = Number(item);
        const bulkInsertModel = new BulkInsertModel();
        bulkInsertModel.screenUrl = this.router.url;
        let itemids = this.impactAssessment.merged_Id.replace('(', '');
        itemids = itemids.replace(')', '');
        bulkInsertModel.itemIds = itemids.split(",").map(Number);
        const index = bulkInsertModel.itemIds.indexOf(item);
        bulkInsertModel.itemIds.splice(index, 1);
        bulkInsertModel.parentId = this.impactAssessment.updatedDB_Id;
        bulkInsertModel.id = this.impactAssessment.id;
        this.isLoading = true;
        this.gdprService.moveToBulkImpactAssessmentT6(bulkInsertModel).subscribe((data: any) => {
          this.isLoading = false;
          let otherIds = bulkInsertModel.itemIds.map(x => x).join(",");
          this.impactAssessment.merged_Id = otherIds;
          if (this.currentinfoId == item) {
            this.getUpdatedDbInfo(this.impactAssessment.updatedDB_Id);
          }
        });
      }
    });
  }
  updateParentId() {
    this.parentId = this.impactAssessment.updatedDB_Id;
    this.isParentIdEdit = true;
  }
  changeParentId() {
    const bulkInsertModel = new BulkInsertModel();
    bulkInsertModel.screenUrl = this.router.url;
    let itemids = this.impactAssessment.merged_Id.replace('(', '');
    itemids = itemids.replace(')', '');
    bulkInsertModel.itemIds = itemids.split(",").map(Number);
    bulkInsertModel.parentId = this.parentId;
    bulkInsertModel.id = this.impactAssessment.id;
    if (this.impactAssessment.updatedDB_Id != this.parentId) {
      this.isLoading = true;
      this.gdprService.moveToBulkImpactAssessment5(bulkInsertModel).subscribe((data: any) => {
        this.impactAssessment.updatedDB_Id = this.parentId;
        this.isParentIdEdit = false;
        this.isLoading = false;
      });
    }
    else {
      this.isParentIdEdit = false;
    }
  }
  //previous next button add
  checkSibling(id: number, type: string): boolean {
    const index = this.idList.findIndex((a) => Number(a)=== Number(id));
    if (index < 0) {
      return false;
    } else {
      if (type === 'Next') {
        return this.idList[index + 1] ? true : false;
      } else {
        return this.idList[index - 1] ? true : false;
      }
    }
  }
  getSiblings(type: string): void {
    const index = this.idList.findIndex(
      (a) => Number(a) === Number(this.impactAssessmentId));
    if (type === 'Next') {
      this.impactAssessmentId = this.idList[index + 1];
    } else {
      this.impactAssessmentId = this.idList[index - 1];
    }
    this.redirectLink();
  }
  redirectLink() {
    let link = '/impact-assessment/details/impact/'+this.impactAssessment.templateNo+'/' + this.impactAssessmentId + '';
    const navigationExtras: NavigationExtras = {
      state: { idList: this.idList }
    };
   this.router.navigate([link], navigationExtras);
  }
}

